import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { ApplicationEditionKey } from '@atlassian/jira-shared-types/src/edition.tsx';
import type { CloudId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { Entitlement, EntitlementGroupDetail, ProductEntitlements } from './types.tsx';

const confluenceEntitlementFilter = (entitlement: Entitlement) =>
	entitlement.productKey === 'confluence.ondemand' ||
	entitlement.productKey === 'confluence.ondemand.billedinccp';

const serviceDeskEntitlementFilter = (entitlement: Entitlement) =>
	entitlement.productKey === 'jira-servicedesk.ondemand' ||
	entitlement.productKey === 'jira-servicedesk.ondemand.billedinccp';

const jiraEntitlementFilter = (entitlement: Entitlement) =>
	entitlement.productKey === 'jira-software.ondemand' ||
	entitlement.productKey === 'jira-software.ondemand.billedinccp';

// CCP returns edition as title case, this function converts to lowercase to standardise
const convertEditionToLowerCase = (entitlement?: Entitlement): Entitlement | undefined =>
	entitlement && {
		...entitlement,
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		edition: entitlement.edition?.toLowerCase() as ApplicationEditionKey,
	};

export const fetchEntitlements = (cloudId: CloudId): Promise<ProductEntitlements> =>
	fetchJson(`/gateway/api/billing-ux/cloud/${cloudId}/billing/v2/site-entitlements`).then(
		(response: EntitlementGroupDetail) => {
			const confluenceEntitlement = response.entitlements.find(confluenceEntitlementFilter);
			const serviceDeskEntitlement = response.entitlements.find(serviceDeskEntitlementFilter);
			const jiraEntitlement = response.entitlements.find(jiraEntitlementFilter);

			return {
				serviceDesk: convertEditionToLowerCase(serviceDeskEntitlement),
				confluence: convertEditionToLowerCase(confluenceEntitlement),
				jiraSoftware: convertEditionToLowerCase(jiraEntitlement),
			};
		},
	);
